// import components
import { styled, Box, BoxProps } from '@mui/material';

export const TooltipBox = styled(Box)<BoxProps>(() => ({
  cursor: 'pointer',
  width: '100%'
}));

export const StyledCapitalizedBox = styled(Box)<BoxProps>(() => ({
  textTransform: 'capitalize'
}));
